export const desktopHeaderHeight = 98;
export const mobileHeaderHeight = 68;
export const buffer = 20;
